import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getEmailBuilderListAll } from '../../../Services';
import { SpinnerComponent } from './NewComponents';
import { AiOutlineSearch } from 'react-icons/ai';
import EmailTemplateCard from './EmailTemplateCard';
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';

interface EmailTemplate {
  _id: string;
  emailName: string;
  previewImage?: string;
}

interface EmailTemplatesProps {
  onSelectTemplate: (template: EmailTemplate) => void;
  setOpenCustomHTML: (isOpen: boolean) => void;
}

const EmailTemplates: React.FC<EmailTemplatesProps> = ({ onSelectTemplate, setOpenCustomHTML }) => {
  const authtoken = useSelector((state: any) => state.main.auth_token);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState<boolean>(false);
  const [templateData, setTemplateData] = useState<EmailTemplate[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const limit = 50;


  useEffect(() => {
    fetchEmailTemplates('', 1);
  }, []);

  const fetchEmailTemplates = async (searchTerm: string = '', _page = 1) => {
    try {
      setIsLoadingTemplates(true);
      console.log('Fetching email templates with page:', _page);
      const response = await getEmailBuilderListAll(authtoken, searchTerm, false, _page, limit);

      if (response?.data) {
        setTemplateData(response.data.data || []);
        setPage(response.data.currentPage);
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      console.error('Error fetching email templates:', error);
    } finally {
      setIsLoadingTemplates(false);
    }
  };

  // Debounced search handler
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  // Debounce search effect
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchEmailTemplates(searchValue, 1);
    }, 400); // 400ms debounce
    return () => clearTimeout(handler);
  }, [searchValue]);


  return (
    <div className='w-100 verythinscrollnew' style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <div className="w-100 verythinscrollnew" style={{ flex: 1, overflowY: 'auto' }}>
        <div className="d-flex justify-content-between" style={{ height: '25px', width: '95%', marginBottom: '20px' }}>
          <div style={{ width: '60%', height: '30px', marginLeft: '16px' }}>
            <div className={'loggedInput'}>
              <AiOutlineSearch size={18} />
              <input
                style={{ width: '100%' }}
                className="input"
                type="text"
                placeholder="Search for templates"
                value={searchValue}
                onChange={handleSearchChange}
                autoComplete="off"
                spellCheck={false}
                aria-label="Search for templates"
              />
            </div>
          </div>
          <div className="d-flex" style={{ width: '7%', marginTop: '6px' }}>
            <img
              src={images.Left}
              style={{
                color: '#3366CC',
                cursor: 'pointer',
                height: '24px',
                marginRight: '16px',
                opacity: page > 1 && page <= totalPages ? 1 : 0.2,
              }}
              onClick={() => {
                if (page > 1 && page <= totalPages) {
                  fetchEmailTemplates(searchValue, page - 1);
                }
              }}
            ></img>
            {/* <p style={{marginLeft:"5px",marginRight:"5px"}}>{"<-->"}</p> */}
            <img
              src={images.Right}
              style={{
                color: '#3366CC', cursor: 'pointer', height: '24px',
                opacity: page < totalPages ? 1 : 0.2,
              }}
              onClick={() => {
                if (page < totalPages) {
                  fetchEmailTemplates(searchValue, page + 1);
                }
              }}
            ></img>
          </div>
          <div style={{ width: 'fit-content', height: '30px', marginLeft: '24px' }}>
            <button
              onClick={() => setOpenCustomHTML(true)}
              className='btn'
              style={{
                backgroundColor: colors.white,
                color: colors.primary03,
                borderRadius: '8px',
                border: `1px solid ${colors.primary03}`,
                padding: '4px 24px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                src={images.UploadIcon}
                alt="upload"
                style={{ width: '20px', height: '20px', marginRight: '4px' }}
              />
              <span>Custom Html file</span>
            </button>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(280px, 1fr))',
          gap: '16px',
          padding: '16px',
          marginBottom: '16px'
        }}>
          {isLoadingTemplates ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px 0' }}>
              <SpinnerComponent />
            </div>
          ) : templateData?.length > 0 ? (
            templateData.map((template) => (
              <EmailTemplateCard
                key={template._id}
                template={template}
                onClick={onSelectTemplate}
              />
            ))
          ) : (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px 0' }}>
              <p style={{ color: '#6B7280', fontSize: '16px' }}>No templates found</p>
              <p style={{ fontSize: '16px', fontWeight: 500, marginBottom: '8px', color: '#333' }}>
                {searchValue
                  ? 'No templates match your search. Try a different term.'
                  : 'You have not created any email templates yet.'}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailTemplates;
